import { lazy } from 'react';
// prettier-ignore
export const Pages = {
    Customer: {
        TuCuenta: lazy(() => import('./Customer/TuCuenta/TuCuentaPage.tsx')),
        Contratar: lazy(() => import('./Customer/Contratar/ContratarPage.tsx')),
        Estadisticas: lazy(() => import('./Customer/Estadisticas/EstadisticasPage.tsx')),
    },
    Admin: {
        PocMarkdown: lazy(() => import('./Admin/PocMarkdownPage.tsx')),
        Suscripciones: lazy(() => import('./Admin/AdminSuscripcionesPage.tsx')),
        Transferencias: lazy(() => import('./Admin/Transferencias/AdminTransferenciasPage.tsx')),
        Dunning: lazy(() => import('./Admin/Transferencias/./AdminDunningPage.tsx')),
        Cuenta: lazy(() => import('./Admin/AdminCuentaPage.tsx')),
        Invoices: lazy(() => import('./Admin/Invoices/AdminInvoicesPage.tsx')),
        Facturas: lazy(() => import('./Admin/Facturas/AdminFacturasPage.tsx')),
        Facturar: lazy(() => import('./Admin/Facturar/AdminFacturarPage.tsx')),
        FacturacionPlanning: lazy(() => import('./Admin/AdminFacturacionPlanningPage.tsx')),
        TusFacturasApiLogPage: lazy(() => import('./Admin/Facturar/AdminTusFacturasApiLogPage.tsx')),
        TusFacturasWebhooksPage: lazy(() => import('./Admin/Facturar/AdminTusFacturasWebhooksPage.tsx')),
        Bloqueadas: lazy(() => import('./Admin/AdminBloqueadasPage.tsx')),
        Mails: lazy(() => import('./Admin/Mails/AdminMailsPage.tsx')),
        Events: lazy(() => import('./Admin/Events/AdminEventsPage.tsx')),
        Dashboard: lazy(() => import('./Admin/Dashboard/AdminDashboardPage.tsx')),
        Usuarios: lazy(() => import('./Admin/AdminUsuariosPage.tsx')),
        Cuentas: lazy(() => import('./Admin/AdminCuentasPage.tsx')),
        Contrataciones: lazy(() => import('./Admin/AdminContratacionesPage.tsx')),
        Planes: lazy(() => import('./Admin/Planes/AdminPlanesPage.tsx')),
        Plan: lazy(() => import('./Admin/Planes/AdminPlanPage.tsx')),
        Cobranzas: lazy(() => import('./Admin/AdminCobranzasPage.tsx')),
        AuditLogs: lazy(() => import('./Admin/AdminAuditLogsPage.tsx')),
        ReportesZenrise: lazy(() => import('./Admin/AdminReportesZenrise.tsx')),
        Trials: lazy(() => import('./Admin/AdminTrialsPage.tsx')),
        Migraciones: lazy(() => import('./Admin/AdminMigracionesPage.tsx')),
        ProcesosDiarios: lazy(() => import('./Admin/ProcesosDiarios/AdminProcesosDiariosPage')),
    },
};
